import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks, WHATSAPP } from '../mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0c0c0e]/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button onClick={() => go('#home')} className="font-display font-bold text-xl tracking-[0.15em] text-white">
          UNREAL VIZ
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l, i) => (
            <button
              key={l.label}
              onClick={() => go(l.href)}
              className="text-sm text-neutral-300 hover:text-white transition-colors relative group"
            >
              {i === 0 && <span className="text-[var(--uv-gold)] mr-1">{'•'}</span>}
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[var(--uv-gold)] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <a
          href={WHATSAPP}
          target="_blank"
          rel="noreferrer"
          className="hidden lg:inline-flex items-center px-5 py-2 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] text-sm font-semibold hover:bg-[var(--uv-gold-soft)] transition-colors"
        >
          Accedi al corso
        </a>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0c0c0e]/98 backdrop-blur-md border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {navLinks.map((l) => (
            <button key={l.label} onClick={() => go(l.href)} className="text-left text-neutral-200 text-lg">
              {l.label}
            </button>
          ))}
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className="mt-2 inline-flex justify-center items-center px-5 py-3 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] font-semibold">
            Accedi al corso
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
